import { Component } from "react";

import "./style.scss";

let id= 0;

class ColorPicker extends Component {

    state = {
        color:"#000000"
    }

    constructor(props){
        super(props);
        this.id = id++;
    }

    colorHandler=(e)=>{
        this.setState({color:e.currentTarget.value});
        this.props.onColorChange(e.currentTarget.value);
    }

    render() {
        return (
            <>
                <label className="input-color" htmlFor={`color-picker-${this.id}`} style={{"--color":this.state.color}}>
                    <span aria-hidden="true">{this.props.text}</span>
                    <input id={`color-picker-${this.id}`} type="color" name="color" onChange={this.colorHandler} />
                </label>
            </>
        )
    }
}

export default ColorPicker;